import { useRouter } from "@tanstack/react-router";

import { Sidebar } from "@/components/ui/layout/sidebar/sidebar";

import type { JSX } from "react";

interface MainElementProps extends React.ComponentPropsWithoutRef<"main"> {
  children: React.ReactNode;
}

/**
 * Main element component that renders the main element of a page - the dominant content of the <body> of a document.
 * Note that only one main element is permitted in a HTML document.
 *
 * @param children - Page component children.
 * @returns JSX.Element - Rendered Page component.
 */
export const MainElement = (props: MainElementProps): JSX.Element => {
  const router = useRouter();
  const isAuthRoute = router.state.location.pathname.includes("/auth");
  const isFlowRoute = router.state.location.pathname.includes("/flows");
  const isCafDocumentBlock = router.state.location.pathname.includes(
    "/caf-documents-blocked",
  );

  const showSidebar = !isAuthRoute && !isFlowRoute && !isCafDocumentBlock;

  return (
    <div className="flex h-screen-with-fallback overflow-hidden bg-white">
      {showSidebar ? <Sidebar /> : null}
      <main
        className="font-poppins flex flex-col flex-1 h-screen-with-fallback overflow-hidden md:overflow-y-auto md:scrollbar-hidden md:relative"
        {...props}
      >
        {props.children}
      </main>
    </div>
  );
};
